<template>
  <AppCarousel
    :breakpoints="{
      851: { itemsToShow: 2 },
      1000: { itemsToShow: 2.6 },
      1250: { itemsToShow: 3.4 },
      1550: { itemsToShow: 4 },
      1800: { itemsToShow: 4.8 },
      1900: { itemsToShow: 4.9 },
      2000: { itemsToShow: 5 },
    }"
    :gap="0"
    height="auto"
    snap-align="start"
    wrap-around navigation elevated
  >
    <AppCarouselSlide v-for="(pair, index) in splitArray(testimonials, 2)" :key="index">
      <div class="flex col self-start gap-6">
        <TestimonialCard 
          v-for="(testimonial, testimonialIndex) in pair" 
          :key="testimonialIndex" 
          :testimonial="testimonial" 
        />
      </div>
    </AppCarouselSlide>
  </AppCarousel>
</template>

<script setup lang="ts">
import type { Testimonial } from '~/types';
import { AppCarousel } from '#components';
import { splitArray } from '~/helpers/general';

defineProps<{
  testimonials: Testimonial[];
}>();
</script>